/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A row of the paged workshops list: `WorkshopRead` without the rich-text description.
 * @export
 * @interface WorkshopListItem
 */
export interface WorkshopListItem {
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    mentor_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    class_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopListItem
     */
    created_at: Date;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopListItem
     */
    is_active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopListItem
     */
    start_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopListItem
     */
    end_time: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    series_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    mentor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopListItem
     */
    class_name?: string | null;
}

/**
 * Check if a given object implements the WorkshopListItem interface.
 */
export function instanceOfWorkshopListItem(value: object): value is WorkshopListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mentor_id' in value) || value['mentor_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    if (!('start_time' in value) || value['start_time'] === undefined) return false;
    if (!('end_time' in value) || value['end_time'] === undefined) return false;
    return true;
}

export function WorkshopListItemFromJSON(json: any): WorkshopListItem {
    return WorkshopListItemFromJSONTyped(json, false);
}

export function WorkshopListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'mentor_id': json['mentor_id'],
        'organization_id': json['organization_id'],
        'class_id': json['class_id'] == null ? undefined : json['class_id'],
        'created_at': (new Date(json['created_at'])),
        'is_active': json['is_active'],
        'start_time': (new Date(json['start_time'])),
        'end_time': (new Date(json['end_time'])),
        'series_id': json['series_id'] == null ? undefined : json['series_id'],
        'mentor_name': json['mentor_name'] == null ? undefined : json['mentor_name'],
        'class_name': json['class_name'] == null ? undefined : json['class_name'],
    };
}

export function WorkshopListItemToJSON(json: any): WorkshopListItem {
    return WorkshopListItemToJSONTyped(json, false);
}

export function WorkshopListItemToJSONTyped(value?: WorkshopListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'topic': value['topic'],
        'mentor_id': value['mentor_id'],
        'organization_id': value['organization_id'],
        'class_id': value['class_id'],
        'created_at': ((value['created_at']).toISOString()),
        'is_active': value['is_active'],
        'start_time': ((value['start_time']).toISOString()),
        'end_time': ((value['end_time']).toISOString()),
        'series_id': value['series_id'],
        'mentor_name': value['mentor_name'],
        'class_name': value['class_name'],
    };
}

